import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "features/auth/AuthSlice";
import pusher from "./Pusher";
import type { Channel } from "pusher-js"; // ✅ Import type explicitly

type EventHandlerMap = {
  [eventName: string]: (data: any) => void;
};

let channel: Channel; // ✅ Persist channel for reuse across hook calls

export const useWhatsAppListener = (handlers: EventHandlerMap) => {
  // The private channel's broadcasting-auth handshake needs the user's Sanctum
  // token, so only subscribe once authenticated. This listener is mounted app-wide
  // (incl. /login); without this guard the auth call 401s in a loop before login.
  const token = useSelector(selectAuth).token;

  useEffect(() => {
    if (!token) return;

    if (!channel) {
      // TO-38127 (f_fesec_cb0cf986c6): private channel — Pusher now requires a
      // server-signed authorization (see Pusher.ts) before subscribing, so the
      // public app key alone can no longer read live WhatsApp messages.
      channel = pusher.subscribe("private-whatsapp-chat");
    }

    // ✅ Bind each handler to the event
    for (const [event, handler] of Object.entries(handlers)) {
      channel.bind(event, handler);
    }

    // Debug connection
    pusher.connection.bind("connected", () => {
      // console.log("✅ Pusher connected in tab");
    });

    // ✅ Unbind only handlers, keep channel alive across tabs
    return () => {
      for (const [event, handler] of Object.entries(handlers)) {
        channel?.unbind(event, handler);
      }
      // pusher.unsubscribe('whatsapp-chat');
    };
  }, [handlers, token]);
};
